import { render, staticRenderFns } from "./CreateComboParam.vue?vue&type=template&id=ba949c12"
import script from "./CreateComboParam.vue?vue&type=script&lang=js"
export * from "./CreateComboParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports